module.exports = __webpack_public_path__ + "static/ip-638595c8a5ee4504fb510e57b9e14f5b.jpeg";